import { useUrl } from 'hooks/useUrl'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { ComponentType } from 'react'
import { GoChevronLeft, GoChevronRight } from 'react-icons/go'
import Paginating from 'react-paginating'
import { Col, Container, Pagination, PaginationItem, PaginationLink, Row } from 'reactstrap'

export const BlogPagination: ComponentType<{
  pagination: any
  loading?: boolean
}> = ({ pagination, loading }) => {
  const router = useRouter()
  const { url } = useUrl()

  return (
    <Paginating total={pagination.total} limit={pagination.limit} pageCount={7} currentPage={pagination.page}>
      {({ pages, currentPage, hasPreviousPage, previousPage, hasNextPage, nextPage }) => (
        <Container className="pt-40">
          <Row>
            <Col>
              <Pagination listClassName="mb-0 justify-content-center">
                <PaginationItem disabled={!hasPreviousPage || loading}>
                  {hasPreviousPage ? (
                    <Link
                      href={router.route}
                      as={{
                        pathname: url.pathname,
                        query: { page: previousPage },
                      }}
                      passHref
                      shallow
                    >
                      <a className="page-link">
                        <GoChevronLeft />
                      </a>
                    </Link>
                  ) : (
                    <PaginationLink>
                      <GoChevronLeft />
                    </PaginationLink>
                  )}
                </PaginationItem>
                {pages.map((page) => (
                  <PaginationItem key={page} active={page === currentPage} disabled={loading}>
                    <Link
                      href={router.route}
                      as={{
                        pathname: url.pathname,
                        query: { page },
                      }}
                      passHref
                      shallow
                    >
                      <a className="page-link">{page}</a>
                    </Link>
                  </PaginationItem>
                ))}
                <PaginationItem disabled={!hasNextPage || loading}>
                  {hasNextPage ? (
                    <Link
                      href={router.route}
                      as={{
                        pathname: url.pathname,
                        query: { page: nextPage },
                      }}
                      passHref
                      shallow
                    >
                      <a className="page-link">
                        <GoChevronRight />
                      </a>
                    </Link>
                  ) : (
                    <PaginationLink>
                      <GoChevronRight />
                    </PaginationLink>
                  )}
                </PaginationItem>
              </Pagination>
            </Col>
          </Row>
        </Container>
      )}
    </Paginating>
  )
}
